import {
  ExchangeRateData,
  ExchangeRateEntities
} from "@/domain/entities/ExchangeRate";
import { Pagination } from "@/domain/entities/Pagination";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { AxiosResponse } from "axios";

export class ExchangeRateDataMapper {
  public convertExchangeRateFromApi(
    result: AxiosResponse<any>
  ): ExchangeRateEntities {
    const { data } = result;
    return new ExchangeRateEntities(
      new Pagination(data.meta.page, data.meta.limit),
      data.data.length === 0
        ? []
        : data.data.map((item: any) => {
            return new ExchangeRateData({
              id: item.exchange_rate_id,
              exchangeRateFrom: item.exchange_rate_from,
              exchangeRateTo: item.exchange_rate_to,
              exchangeRate: item.exchange_rate,
              status: item.exchange_rate_status,
              effectiveDate: item.exchange_rate_effective_date,
              createdAt: item.exchange_rate_created_at,
              updatedAt: item.exchange_rate_updated_at,
              createdBy: item.exchange_rate_created_by,
              updatedBy: item.exchange_rate_updated_by,
              exchangeRateCountryNameFrom: item.exchange_rate_country_name_from,
              exchangeRateCountryNameTo: item.exchange_rate_country_name_to
            });
          })
    );
  }

  public convertDetailExchangeRateFromApi(
    result: AxiosResponse<any>
  ): ExchangeRateData {
    const { data } = result;
    return new ExchangeRateData({
      id: data.data.exchange_rate_id,
      exchangeRateFrom: data.data.exchange_rate_from,
      exchangeRateTo: data.data.exchange_rate_to,
      exchangeRate: data.data.exchange_rate,
      status: data.data.exchange_rate_status,
      effectiveDate: data.data.exchange_rate_effective_date,
      createdAt: data.data.exchange_rate_created_at,
      updatedAt: data.data.exchange_rate_updated_at,
      createdBy: data.data.exchange_rate_created_by,
      updatedBy: data.data.exchange_rate_updated_by,
      exchangeRateCountryNameFrom: data.data.exchange_rate_country_name_from,
      exchangeRateCountryNameTo: data.data.exchange_rate_country_name_to
    });
  }

  public convertChangeDataFromApi(result: AxiosResponse<any>): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      success: data.success,
      message: data.message
    });
  }
}
